import { render, staticRenderFns } from "./vehicleSupervise.vue?vue&type=template&id=fbe8adfa&scoped=true"
import script from "./vehicleSupervise.vue?vue&type=script&lang=js"
export * from "./vehicleSupervise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe8adfa",
  null
  
)

export default component.exports